import { useMutation } from "@apollo/client";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";

import styles from "@components/account/Account.module.css";
import Button from "@components/buttons/Button";
import DeleteAccountConfirmation from "@components/DeleteAccountConfirmation";
import Heading2 from "@components/typography/Heading2";
import useMyClient from "@hooks/useMyClient";
import useOpener from "@hooks/useOpener";
import { ClientEraseDocument, ClientEraseMutation, ClientEraseMutationVariables } from "@typing/Generated";

const SecurityAccountDeletion = () => {
  const [clientErase] = useMutation<ClientEraseMutation, ClientEraseMutationVariables>(ClientEraseDocument);
  const accountDeletionConfirmationOpener = useOpener();
  const myClient = useMyClient();
  const history = useHistory();

  const handleAccountDelete = () => {
    if (myClient) {
      clientErase().then(() => history.push("/sign-out"));
    }
  };

  return (
    <div>
      <Heading2 color="danger">
        <FormattedMessage id="pages.client.account.dangerZone" />
      </Heading2>
      <div className={styles.sectionBody}>
        <div className="ion-margin-bottom">
          <FormattedMessage id="pages.client.account.deleteMyAccountExplanation" />
        </div>
        <Button onClick={accountDeletionConfirmationOpener.open}>
          <strong>
            <FormattedMessage id="pages.client.account.deleteMyAccount" />
          </strong>
        </Button>
      </div>
      <DeleteAccountConfirmation onDelete={handleAccountDelete} opener={accountDeletionConfirmationOpener} />
    </div>
  );
};

export default SecurityAccountDeletion;
